<template>
  <div>
    <!-- Mobile: Tabs -->
    <template v-if="device.isMobile">
      <v-tabs v-model="activeTab" grow color="primary" slider-color="primary">
        <v-tab v-for="shift in shiftsWithMeals" :key="shift.key" class="text-none">
          {{ getShiftName(shift) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="(shift, index) in shiftsWithMeals" :key="shift.key">
          <div class="pa-2">
            <template v-for="meal in shift.meals">
              <worker-menu-food-card
                v-if="orderRules.isWorker"
                :meal="meal"
                :daily-menu="item"
                :order="dailyOrder"
                :shift="shift.text"
                :disabled="isMenuDisabled"
              >
              </worker-menu-food-card>
              <company-menu-food-card
                v-else
                :meal="meal"
                :daily-menu="item"
                :shift="shift.text"
                :disabled="isMenuDisabled"
              />
            </template>
            <div
              class="px-4 py-2 mt-4 rounded-lg grey lighten-4"
              v-if="!orderRules.isWorker"
            >
              <v-row no-gutters justify="space-between" align="center">
                <span>{{ $t("total") }}</span>
                <span class="font-weight-bold">
                  {{
                    shift.meals
                      .filter((meal) => meal.order)
                      .reduce((acc, meal) => acc + meal.order.quantity, 0)
                  }}
                </span>
              </v-row>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <!-- Desktop: Columns -->
    <v-row v-else align="start">
      <v-col
        v-for="shift in item.shifts"
        cols="12"
        :lg="withDimension"
        :key="shift.key"
        v-if="shift.meals.length"
      >
        <shift-header :shift="shift"></shift-header>

        <template v-for="meal in shift.meals">
          <worker-menu-food-card
            v-if="orderRules.isWorker"
            :meal="meal"
            :daily-menu="item"
            :order="dailyOrder"
            :shift="shift.text"
            :disabled="isMenuDisabled"
          >
          </worker-menu-food-card>
          <company-menu-food-card
            v-else
            :meal="meal"
            :daily-menu="item"
            :shift="shift.text"
            :disabled="isMenuDisabled"
          />
        </template>
        <div class="px-4 py-2 mt-4 rounded-lg grey lighten-4" v-if="!orderRules.isWorker">
          <v-row no-gutters justify="space-between" align="center">
            <span>{{ $t("total") }}</span>
            <span class="font-weight-bold">
              {{
                shift.meals
                  .filter((meal) => meal.order)
                  .reduce((acc, meal) => acc + meal.order.quantity, 0)
              }}
            </span>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CompanyMenuFoodCard from "@/components/companyMenu/cards/CompanyMenuFoodCard.vue";
import WorkerMenuFoodCard from "@/components/companyMenu/cards/WorkerMenuFoodCard.vue";
import { changeDay } from "@/utils/dayShiftUtil";
import ShiftHeader from "@/components/companyMenu/components/ShiftHeader.vue";
import moment from "moment";

export default {
  name: "ShiftMealsColumns",
  components: { CompanyMenuFoodCard, WorkerMenuFoodCard, ShiftHeader },
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    currentMenuDate() {
      return this.$store.state.companyMenu.currentMenuDate;
    },
    minOrderDate() {
      return this.$store.state.companyMenu.minOrderDate;
    },
    isMenuDisabled() {
      const isBeforeMinOrderDate = moment(this.currentMenuDate).isBefore(
        this.minOrderDate,
        "day"
      );
      const isBeforeCurrentDate = moment(this.currentMenuDate).isBefore(moment(), "day");
      return (
        isBeforeMinOrderDate && (!this.user?.no_time_limit_user || isBeforeCurrentDate)
      );
    },
    shiftsWithMeals() {
      return this.item.shifts.filter((shift) => shift.meals.length > 0);
    },
    dailyOrder() {
      const shiftWithMeal = this.item.shifts.find((shift) =>
        shift.meals.some((meal) => meal.order)
      );
      return shiftWithMeal ? shiftWithMeal.meals.find((meal) => meal.order) || {} : {};
    },
    company() {
      return this.$store.state.company || {};
    },
    companies() {
      return this.$store.state.companies || [];
    },
    user() {
      return this.$store.state.user.user || {};
    },
    orderRules() {
      return this.$store.state.user.orderRules;
    },
    headers() {
      const baseHeaders = [
        {
          text: "Прва смјена",
          value: "shift_one",
          sortable: false,
          align: "center",
          width: "33%",
          shift_code: "shift_1",
        },
        {
          text: "Друга смјена",
          value: "shift_two",
          sortable: false,
          align: "center",
          width: "33%",
          shift_code: "shift_2",
        },
        {
          text: "Трећа смјена",
          value: "shift_three",
          sortable: false,
          align: "center",
          width: "33%",
          shift_code: "shift_3",
        },
      ];
      let headers = [];
      if (this.company) {
        if (this.company.shift_one) headers.push(baseHeaders[0]);
        if (this.company.shift_two) headers.push(baseHeaders[1]);
        if (this.company.shift_three) headers.push(baseHeaders[2]);
      } else {
        headers = [...baseHeaders];
      }
      if (this.user.type === "guest") {
        headers.push({
          text: "Твоја наруџба",
          value: "korpa",
          sortable: false,
          align: "center",
          width: "15%",
        });
      }
      return headers;
    },
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.company.restaurant;
    },
    withDimension() {
      const count =
        (this.company.shift_one ? 1 : 0) +
        (this.company.shift_two ? 1 : 0) +
        (this.company.shift_three ? 1 : 0);
      if (this.device.isMobile) {
        if (count === 1) return 12;
        if (count >= 3 && count <= 5) return 6;
        if (count === 6) return 4;
        return 12;
      }
      return 4;
    },
  },
  methods: {
    changeDay,
    getShiftName(shift) {
      const translation = (this.$store.state.company?.shift_translations || []).find(
        (st) => {
          return st.shift_code === shift.code && st.language_code === this.$i18n.locale;
        }
      );
      return translation?.label || this.$t(shift.code) || shift.name || shift.code;
    },
  },
};
</script>
